'use client';

const EARN_ROWS = [
  { points: '+1', label: 'every on-time daily payment' },
  { points: '+7', label: 'every on-time weekly payment' },
  { points: '+30', label: 'every on-time monthly payment' },
] as const;

/**
 * "How your trust level grows" block with the +1 / +7 / +30 earn rows.
 * Shared across NewUser and Progressing states.
 */
export function EarnRows({ title = 'How your trust level grows' }: { title?: string }) {
  return (
    <div className="flex flex-col gap-1.5">
      <p className="text-[14px] font-extrabold text-[#0C0C0C]">{title}</p>
      {EARN_ROWS.map(({ points, label }) => (
        <div key={points} className="flex items-center gap-2.5 py-2">
          <span className="text-[16px] font-extrabold text-motito-green">
            {points}
          </span>
          <span className="text-[13px] font-medium text-[#374151]">{label}</span>
        </div>
      ))}
    </div>
  );
}

export default EarnRows;
